import React, { useState, useRef, useEffect } from 'react';

import Icon from 'components/commons/icon/Icon';
import Loading from 'components/commons/loading/Loading';

import * as api from 'config/api';

import { useRouting } from 'hooks/useRouting';
import { useScroll } from 'hooks/useScroll';
import { formatDateForString } from 'utils/formatter';

type SymbolNewsProps = {
  symbol: string;
};

const SymbolNews: React.FC<SymbolNewsProps> = ({ symbol }) => {
  const routing = useRouting();
  const unmounted = useRef<boolean>(false);

  const [news, setNews] = useState<api.GetSymbolNewsResult | null>();

  useEffect(() => {
    return () => {
      // unmount
      unmounted.current = true;
    };
  }, []);

  useEffect(() => {
    api.getSymbolNews(symbol).then(ret => {
      if (!unmounted.current) {
        setNews(ret);
      }
    });
  }, [setNews, symbol]);

  const goDetail = (id: string) => {
    return (): void => {
      routing.pushRouting(
        { path: `/news/${symbol}/${id}` },
        true,
        window.scrollY
      );
    };
  };

  const list = news?.Items.map((x, i) => {
    return (
      <tr
        className="border-b border-gray-300 cursor-pointer"
        key={i}
        onClick={goDetail(x.ID)}>
        <td className="pl-4 pr-2 py-2">
          <div className="flex items-center">
            <div className="w-11/12">
              <div className="text-sm truncate">{x.Title}</div>
              <div className="text-sm text-gray-500">
                {formatDateForString(x.Date, 'M/d HH:mm')}
              </div>
            </div>
            <Icon name="chevron-right" className="text-2xl text-gray-500" />
          </div>
        </td>
      </tr>
    );
  });

  useScroll();

  return (
    <div>
      <table className="w-full table-fixed">
        <tbody>
          {news === null || news === undefined ? (
            <Loading
              loading={true}
              circularLoading={true}
              style={{
                paddingTop: '100px',
                paddingBottom: '100px',
              }}
            />
          ) : (
            list
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SymbolNews;
